export type SidebarLink = [string, string, string] | [string, string, undefined, string] | [string, string, string, string]

interface NavigationState {
  links: SidebarLink[]
  organisationId: string | null
}

const defaultLinks: SidebarLink[] = [
  ['home', 'Home', '/dashboard'],
  ['company', 'Companies', '/companies'],
  ['users', 'Participants', '/participants'],
  ['lightbulb-group-outline', 'Committees', '/committees'],
  // ['mdi-account-group', 'Licensed Assessors', 'Dashboard'],
  // ['mdi-file-tree-outline', 'Organisations', 'Dashboard'],
  // ['mdi-text-box-multiple-outline', 'Projects', 'Dashboard'],
  ['clipboard', 'Questionnaires', '/questionnaires'],
  ['upload-multiple', 'Bulk Import', '/import'],
  ['shield-account-outline', 'Platform Administrators', '/platform-administrators']
]

const persistentLinks: SidebarLink[] = [
  ['help-circle', 'FAQ', undefined, 'kbs'] // External Knowledge-base System (Zendesk)
]

const boardMemberLinks: SidebarLink[] = [
  ['gauge', 'Activity', '/dashboard']
  // ['document', 'Reports', '/reports']
]

const defaultState = (): NavigationState => ({
  links: [],
  organisationId: null
})

function getOrganisationDashboardLink (): SidebarLink {
  return ['hierarchy', 'Organisation Dashboard', '/organisation/dashboard', 'organisationDashboard']
}

function getOrganisationUserManagementLink (): SidebarLink {
  return ['account-supervisor-circle-outline', 'Organisation Users', '/organisation/users', 'organisationUsers']
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setDefaultLinks: (state: NavigationState): void => {
      const links = [...defaultLinks]
      if (state.organisationId) {
        links.push(getOrganisationDashboardLink())
        links.push(getOrganisationUserManagementLink())
      }
      state.links = [...links, ...persistentLinks]
    },
    setAnalysisLinks: (state: NavigationState): void => {
      state.links = [...persistentLinks]
    },
    setBoardMemberLinks: (state: NavigationState) => (state.links = boardMemberLinks),
    setOrganisationId: (state: NavigationState, organisationId: string | null): void => {
      state.organisationId = organisationId
    }
  }
}
